export default __webpack_public_path__ + "static/media/detailsInfo.31ecf888.svg";